import loadable from '@loadable/component'
import {
  mq,
  spacing,
  styled,
  Text,
  TextStyle,
} from '@thg-commerce/gravity-theme'
import { PlatformMessage, DrawFocus } from '@thg-commerce/gravity-elements'
import { WishlistButton } from '@thg-commerce/enterprise-components'

const Close = loadable(
  () => import('@thg-commerce/gravity-icons/src/components/Trash'),
  { ssr: true, fallback: <div style={{ width: 24, height: 24 }} /> },
)

export const Container = styled.div<{
  hasDiscounts?: boolean
  priceHidden?: boolean
  showWishlist?: boolean
  maxOrderVisible: boolean
  showClickAndCollect?: boolean
  showItemErrors?: boolean
  outOfStockError?: boolean
}>`
  display: grid;
  display: -ms-grid;
  grid-column-gap: ${spacing(2)};
  grid-row-gap: ${spacing(2)};
  grid-template-columns: auto 1fr auto;
  -ms-grid-columns: auto 1fr auto;
  grid-template-rows: repeat(
    ${({
      showWishlist,
      hasDiscounts,
      maxOrderVisible,
      showClickAndCollect,
      showItemErrors,
      outOfStockError,
    }) =>
      9 -
      [
        showWishlist,
        hasDiscounts,
        maxOrderVisible,
        showClickAndCollect,
        showItemErrors,
        outOfStockError,
      ].filter((value) => !value).length},
    auto
  );
  -ms-grid-rows: (auto) [
    ${({
      showWishlist,
      hasDiscounts,
      maxOrderVisible,
      showClickAndCollect,
      showItemErrors,
      outOfStockError,
    }) =>
      9 -
      [
        showWishlist,
        hasDiscounts,
        maxOrderVisible,
        showClickAndCollect,
        showItemErrors,
        outOfStockError,
      ].filter((value) => !value).length}];
  grid-template-areas:
    'image name delete'
    'image subtotal delete'
    ${(props) => props.hasDiscounts && `"image discount delete"`}
    ${(props) => props.showWishlist && `"image wishlist delete"`}
    ${(props) => props.showClickAndCollect && `"image clickandcollect delete"`}
    ${(props) => props.showItemErrors && `"image itemerrors delete"`}
    'image quantity delete'
    ${(props) => props.maxOrderVisible && `"image limit delete"`}
    ${(props) => props.outOfStockError && `"image outofstockerror delete"`};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    grid-template-columns: auto 1fr 144px 100px 48px;
    -ms-grid-columns: auto 1fr 144px 100px 48px;
    grid-template-rows: repeat(
      ${({
        showWishlist,
        hasDiscounts,
        maxOrderVisible,
        showClickAndCollect,
        showItemErrors,
        outOfStockError,
      }) =>
        7 -
        [
          hasDiscounts,
          showWishlist,
          showClickAndCollect,
          showItemErrors,
          outOfStockError,
          maxOrderVisible &&
            !hasDiscounts &&
            !showWishlist &&
            !showClickAndCollect &&
            !showItemErrors &&
            !outOfStockError,
        ].filter((value) => !value).length},
      auto
    );
    -ms-grid-rows: (auto) [
      ${({
        showWishlist,
        hasDiscounts,
        maxOrderVisible,
        showClickAndCollect,
        showItemErrors,
        outOfStockError,
      }) =>
        7 -
        [
          hasDiscounts,
          showWishlist,
          showClickAndCollect,
          showItemErrors,
          maxOrderVisible &&
            !hasDiscounts &&
            !showWishlist &&
            !showClickAndCollect &&
            !showItemErrors &&
            !outOfStockError,
        ].filter((value) => !value).length}];
    grid-template-areas:
      'image name quantity subtotal delete'
      ${(props) => props.hasDiscounts && `"image discount limit limit limit"`}
      ${(props) => props.showWishlist && `"image wishlist limit limit limit"`}
      ${(props) =>
        props.showClickAndCollect &&
        `"image clickandcollect limit limit limit"`}
      ${(props) =>
        props.showItemErrors && `"image itemerrors limit limit limit"`}
      ${(props) =>
        props.maxOrderVisible &&
        !props.hasDiscounts &&
        !props.showWishlist &&
        !props.showClickAndCollect &&
        !props.showItemErrors &&
        `"image wishlist limit limit limit"`}
      ${(props) =>
        props.outOfStockError && `"image outofstockerror limit limit limit"`};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    grid-column-gap: ${spacing(4)};
    grid-template-columns: ${(props) =>
      props.priceHidden
        ? `auto 1fr 144px 100px 48px`
        : `auto 1fr 108px 144px 100px 48px`};
    -ms-grid-columns: ${(props) =>
      props.priceHidden
        ? `auto 1fr 144px 100px 48px`
        : `auto 1fr 108px 144px 100px 48px`};
    grid-template-areas:
      ${(props) =>
        props.priceHidden
          ? `"image name quantity subtotal delete"`
          : `"image name price quantity subtotal delete"`}
      ${(props) =>
        props.priceHidden && props.hasDiscounts
          ? `"image discount limit limit limit"`
          : !props.priceHidden && props.hasDiscounts
          ? `"image discount . limit limit limit"`
          : ''}
      ${(props) =>
        props.priceHidden && props.showWishlist
          ? `"image wishlist limit limit limit"`
          : !props.priceHidden && props.showWishlist
          ? `"image wishlist . limit limit limit"`
          : ''}
      ${(props) =>
        props.priceHidden && props.showClickAndCollect
          ? `"image clickandcollect limit limit limit"`
          : !props.priceHidden && props.showClickAndCollect
          ? `"image clickandcollect . limit limit limit"`
          : ''}
      ${(props) =>
        props.priceHidden && props.showItemErrors
          ? `"image itemerrors limit limit limit"`
          : !props.priceHidden && props.showItemErrors
          ? `"image itemerrors . limit limit limit"`
          : ''}
      ${(props) =>
        props.priceHidden &&
        props.maxOrderVisible &&
        !props.showWishlist &&
        !props.hasDiscounts &&
        !props.showClickAndCollect &&
        !props.outOfStockError &&
        !props.showItemErrors
          ? `"image wishlist limit limit limit"`
          : !props.priceHidden &&
            props.maxOrderVisible &&
            !props.showWishlist &&
            !props.hasDiscounts &&
            !props.showClickAndCollect &&
            !props.outOfStockError &&
            !props.showItemErrors
          ? `"image wishlist . limit limit limit"`
          : ''}
      ${(props) =>
        props.priceHidden && props.outOfStockError
          ? `"image outofstockerror limit limit limit"`
          : !props.priceHidden && props.outOfStockError
          ? `"image outofstockerror . limit limit limit"`
          : ''};
  }
`
export const ProductImageLink = styled.a`
  width: 77px;
  grid-area: image;
  ${DrawFocus()}
`

export const Name = styled.a`
  text-decoration: none;
  grid-area: name;
  ${DrawFocus()}
`

export const Discount = styled.div`
  grid-area: discount;
`

export const StyledPlatformMessage = styled(PlatformMessage)`
  background: none;
  padding: 0;
`

export const UnitPrice = styled.div<{ hide?: boolean; fontStyle: TextStyle }>`
  grid-area: price;
  display: none;
  width: 100px;

  ${(props) => Text('bodyText', props.fontStyle)}

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    align-self: center;
    padding-left: ${spacing(2)};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: ${(props) => (props.hide ? 'none' : 'block')};
  }
`

export const TotalPrice = styled.div<{ fontStyle: TextStyle }>`
  grid-area: subtotal;

  ${(props) => Text('bodyText', props.fontStyle)}

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    width: 70px;
    align-self: center;
    padding-left: ${spacing(2)};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    width: 100px;
  }
`

export const QuantitySelectorContainer = styled.div`
  grid-area: quantity;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin: auto 0;
    width: 144px;
  }
`

export const QuantityPlaceholder = styled.div`
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    width: 144px;
    text-align: center;
  }
`

export const MaxOrderMessage = styled(PlatformMessage)`
  grid-area: limit;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
`

export const WishlistContainer = styled(WishlistButton)`
  grid-area: wishlist;
  justify-self: flex-start;
  align-self: flex-start;
`

export const RemoveItemContainer = styled.div`
  grid-area: delete;
  width: 40px;
  height: 40px;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    align-self: center;
  }
`

export const RemoveItem = styled.button`
  ${DrawFocus()}

  cursor: pointer;
  width: 40px;
  height: 40px;
  ${DrawFocus()}
`

export const Separator = styled.hr`
  border-top: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  margin: ${spacing(1)} 0 ${spacing(3)} 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin: ${spacing(3)} 0;
  }
`

export const IconContainer = styled.span`
  width: 24px;
  height: 24px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`

export const StyledClose = styled(Close)`
  width: 18px;
  height: 18px;
`
